module.exports = __webpack_public_path__ + "static/media/oracle.a4e0b466.jpg";